// extracted by mini-css-extract-plugin
module.exports = {"container":"TopicButtons_container__1Gx9x","topicsList":"TopicButtons_topicsList__2AiQD","topicLink":"TopicButtons_topicLink__3Tq40"};